import { EOD_ENABLE_STEP, EOD_UPDATE_STEP, EOD_SET_STEP_ACTIVE, EOD_CLEAR_STATE, END_OF_DAY_INITIAL_STATE, END_EOD_PROCESS, START_EOD_PROCESS } from './chunk-Z64XWHIM.mjs';
import { produce } from 'immer';

var endOfDayReducer = produce((state = END_OF_DAY_INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case START_EOD_PROCESS:
      state.isEndOfDayActive = true;
      break;
    case END_EOD_PROCESS:
      state.isEndOfDayActive = false;
      break;
    case EOD_CLEAR_STATE:
      return END_OF_DAY_INITIAL_STATE;
    case EOD_SET_STEP_ACTIVE: {
      Object.values(state.steps).forEach((step2) => {
        step2.isActive = false;
      });
      const { step, isActive } = payload;
      state.steps[step].isActive = isActive;
      break;
    }
    case EOD_UPDATE_STEP: {
      const step = state.steps[payload.step];
      Object.assign(step, payload.stepBody);
      break;
    }
    case EOD_ENABLE_STEP: {
      const { step, isDisabled } = payload;
      state.steps[step].isDisabled = isDisabled;
      break;
    }
    default:
      return state;
  }
});

export { endOfDayReducer };
